// @ts-nocheck
export namespace Is {
  export const validateIranianSheba = str => {
    str = str.replace('i', '');
    str = str.replace('I', '');
    str = str.replace('r', '');
    str = str.replace('R', '');
    str = `IR${str}`;

    const pattern = /^(?:(i|I)(r|R))(?=.{24}$)[0-9]*$/;
    if (str.length !== 26 ) {
      return false;
    }

    if (!pattern.test(str)) {
      return false;
    }
    let newStr = str.substr(4);
    const d1 = str.charCodeAt(0) - 65 + 10;
    const d2 = str.charCodeAt(1) - 65 + 10;
    newStr += d1.toString() + d2.toString() + str.substr(2, 2);

    const remainder = iso7064Mod97(newStr);
    if (remainder !== 1) {
      return false;
    }

    return true;
  };

  export const isNotBluBank = str => {
    if ( str?.slice(6,10)==='6118') { 
      return false;
    }
    return true;
  };

  const iso7064Mod97 = iban => {
    let remainder = iban;
    let block;
    while (remainder.length > 2) {
      block = remainder?.slice(0, 9);
      remainder = (parseInt(block, 10) % 97) + remainder?.slice(block.length);
    }

    return parseInt(remainder, 10) % 97;
  };

  export const email = (str?: string) => {
    const regEx = new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
    return !!str && regEx.test(String(str).toLowerCase());
  };

  export const phoneNumber = (str?: string) => {
    const regEx = new RegExp('^(\\+98|0)?9\\d{9}$');
    return !!str && regEx.test(str);
  };

  export const nationalCode = (str?: string) => {
    if (!/^\d{10}$/.test(str)) return false;
    const check = +str[9];
    const sum =
      str
        .split('')
        ?.slice(0, 9)
        .reduce((acc, x, i) => acc + +x * (10 - i), 0) % 11;
    return sum < 2 ? check === sum : check + sum === 11;
  };

  export const persianNumber = (num) => {
    const persianDigitRegex = /^[۰-۹]+$/;
    return persianDigitRegex.test(num);
  }

  export const englishNumber = (str) => {
    const englishNumberRegex = /^[+-]?\d+(\.\d+)?$/;
    return englishNumberRegex.test(str);
  }

}
